import { mapActions } from 'vuex'

export const ratingContentMixin = {
  data() {
    return {
      rating: null,
      isRatingLoading: true,
      isRatingModalOpen: false,
      contentRatingPayload: {
        model_id: null,
        model_type: null,
      },
    }
  },
  computed: {
    isRatingConfirmed() {
      return this.rating && this.rating.confirmed
    },
  },
  methods: {
    ...mapActions('content', ['getContentRatingByModel']),
    async fetchRating() {
      this.isRatingLoading = true

      const { results } = await this.getContentRatingByModel(
        this.contentRatingPayload
      )

      if (results.length) this.rating = results[0]

      this.isRatingLoading = false
    },
    openRatingModal() {
      this.isRatingModalOpen = true
    },
    closeRatingModal() {
      this.isRatingModalOpen = false
    },
    closeRatingModalAndRefresh() {
      this.closeRatingModal()
      this.fetchRating()
    },
  },
}

export default ratingContentMixin
